// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"e3df8f43","530":"27952759"}[chunkId] + ".chunk.js";
};